import { render, staticRenderFns } from "./UserRoleList.vue?vue&type=template&id=1cb4024d&scoped=true"
import script from "./UserRoleList.vue?vue&type=script&lang=js"
export * from "./UserRoleList.vue?vue&type=script&lang=js"
import style0 from "./UserRoleList.vue?vue&type=style&index=0&id=1cb4024d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb4024d",
  null
  
)

/* custom blocks */
import block0 from "./UserRoleList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports